<template>
    <div class="page noScroll">
        <div class="page-content infinite-scroll noScroll">
            <!-- banner -->
            <div class="travelDetail-banner scroll-container">
                <TravelNoteDetailBanner :bannerList="bannerList"></TravelNoteDetailBanner>
                <div class="travelDetail-bannerTxt">{{articlePartView.title}}</div>
            </div>
            <!-- simply travel information -->
            <div class="travelDetail-info scroll-container">
                <div class="travelDetail-infoTop">
                    <div class="travelDetail-infoTopL">
                        <img :src="articlePartView.authorHeadImg ? articlePartView.authorHeadImg : authorHeadImg">
                        <span>{{articlePartView.author}}</span>
                    </div>
                    <div class="travelDetail-infoTopR praiseNoteBtn" @click="upVote">
                        <img src="../../assets/review-like.png">
                        <span class="praiseNumber">{{articlePartView.score}}</span>
                    </div>
                </div>
                <div class="travelDetail-infoMain">
                    <div class="travelDetail-itemOverFloat">
                        <div class="travelDetail-itemLeft">发布时间:{{articlePartView.updatedTime}}</div>
                        <div class="travelDetail-itemRight">乘坐游轮: <a v-if="articlePartView.shipLink" :href="articlePartView.shipLink" class="external">{{articlePartView.shipName}}</a><span v-else>{{articlePartView.shipName}}</span></div>
                    </div>
                    <div class="travelDetail-itemOverFloat">
                        <div class="travelDetail-itemLeft">出行时间:{{articlePartView.sailDate}}</div>
                        <div class="travelDetail-itemRight">晚数:{{sailDays}}天{{articlePartView.sailNights}}晚</div>
                    </div>
                    <div class="travelDetail-itemOverFloat">
                        <div>行程:{{articlePartView.route}}</div>
                    </div>
                    <div class="travelDetail-itemTags">
                        <div v-for="(item, index) in tags" :key="index"><span>{{item}}</span></div>
                    </div>
                </div>
            </div>

            <!-- travel intro -->
            <div class="travelDetail-intro scroll-container">
                <div class="travelDetail-introTitle">
                    <div class="travelDetail-introTxt">行程概要</div>
                    <div class="travelDetail-introTxtLine"></div>
                </div>

                <!-- 菜单 -->
                <TravelNoteDetailSlideTop
                    :dataList="groups"
                    :activeDay="activeDay"
                    @on-slide-to="slideTo"></TravelNoteDetailSlideTop>

                <div class="travelDetail-introNotes">
                    <div class="travelDetail-introNotesCon">
                        <div class="introNotesCon-title">写在最前</div>
                        <div class="introNotesCon-paragraph" v-html="articlePartView.beforeText"></div>
                    </div>
                    <div :class="`travelDetail-introNotesCon travelDetail-${item.day}`" v-for="item in reviewDaily" :key="item.day">
                        <div class="introNotesCon-title">{{item.dayTitle}} {{item.title}}</div>
                        <div class="introNotesCon-paragraph" v-html="item.content"></div>
                    </div>
                </div>
            </div>

            <!-- pre/next button -->
            <div class="travelDetail-button scroll-container">
                <div class="travelDetail-buttonItem travelDetail-preBtn" v-if="preArticlePartView">
                    <button>上一篇</button>
                    <p>{{interceptText(preArticlePartView.title)}}</p>
                    <a class="hold-link external"
                    :href="`/Rccl.Review/Travel/d-${this.countryName == '' ? 'n':this.countryName}-${this.shipName==''?'n':this.shipName}-${this.orderBy}-${this.offset-1}-${preArticlePartView.id}.html`"
                    ></a>
                </div>
                <div class="travelDetail-buttonItem travelDetail-nextBtn" v-if="nextArticlePartView">
                    <button>下一篇</button>
                    <p>{{interceptText(nextArticlePartView.title)}}</p>
                    <a class="hold-link external" :href="`/Rccl.Review/Travel/d-${this.countryName == '' ? 'n':this.countryName}-${this.shipName==''?'n':this.shipName}-${this.orderBy}-${this.offset+1}-${nextArticlePartView.id}.html`"></a>
                </div>
            </div>

            <!-- share/praise -->
            <div class="travelDetail-operate scroll-container">
                <div class="travelDetail-shareOp praiseNoteBtn" @click="upVote">
                    <img src="../../assets/review-like.png" class="">
                    <span class="praiseNumber">{{articlePartView.score}}</span>
                </div>
                <div class="travelDetail-praiseOp shareNoteBtn travelDetail-infoShareBtn" @click="shareArticle">
                    <div>
                        <img src="../../assets/shareIcon.png">
                    </div>
                    <span>分享</span>
                </div>
            </div>

            <!-- see similarity cruise -->
            <div class="travelDetail-otherCruise scroll-container">
                <a class="hold-link external" href="javascript: void(0)" @click="toSimilar(articlePartView.route)">查看相似航线</a>
            </div>

            <!-- write memories -->
            <div class="travelDetail-memories scroll-container">
                <img src="../../assets/writeIconpng.png">
                <span>请至PC端撰写您的旅途回忆</span>
            </div>

            <!-- 爆款推荐 -->
            <div class="shipDetail-hotCruise scroll-container">
                <PromoCruise></PromoCruise>
            </div>
        </div>

        <!-- 悬浮菜单 -->
        <TravelNoteDetailSlideFixed
                :dataList="groups"
                :isFixed="isFixed"
                :activeDay="activeDay"
                @on-slide-to="slideTo"></TravelNoteDetailSlideFixed>

        <Share :isActive="shareActive"
               :status="currentStatus"
               :isShowCamera="isShowCamera"
               :shareText="shareText"
               :shareUrl="shareUrl"
               :shareImage="shareImage"
               @on-goTop="goTop"></Share>
    </div>
</template>

<script>
    import api from '@/api'
    import wechatHelper from '@/utilities/wechatHelper'
    import TravelNoteDetailBanner from '@/components/Review/TravelNoteDetailBanner.vue'
    import PromoCruise from '@/components/Cruise/PromoCruise'
    import Share from '@/components/Review/Share.vue'
    import TravelNoteDetailSlideTop from '@/components/Review/TravelNoteDetailSlideTop.vue'
    import TravelNoteDetailSlideFixed from '@/components/Review/TravelNoteDetailSlideFixed.vue'
    import { interceptChar } from '@/utilities/tools'
    export default {
        name: 'TravelNoteDetail',
        components: {
            TravelNoteDetailBanner,
            PromoCruise,
            Share,
            TravelNoteDetailSlideTop,
            TravelNoteDetailSlideFixed
        },
        data () {
            return {
                userToken: '',
                detail: {},
                travelId: '',
                bannerList: [],
                articlePartView: '',
                authorHeadImg: 'https://resource.rcclchina.com.cn/logo/MB/logoAvatarCircleBlueLarge.png',
                tags: [],
                shareActive: false,
                currentStatus: 15,
                isShowCamera: false,
                reviewDaily: [],
                groups: [],
                isFixed: false,
                activeDay: 0,
                preArticlePartView: null,
                nextArticlePartView: null,
                dayItemTops: [],
                shareUrl: "",
                shareImage: "",
                shareText: "我刚刚在@皇家加勒比国际游轮 发现一篇#精彩游轮游记# 还不赶快去看看。",
                countryName: '',
                shipName: '',
                orderBy: 0,
                offset: 0,
            }
        },
        beforeMount () {
            console.log("travel note detail")
            this.$store.commit('SET_PAGE_TITLE', '游记攻略')
            this.showPage()
        },
        mounted () {
            document.querySelector('.page-content').addEventListener('scroll', this.handleScroll, false)
            this.shareUrl = window.location.href
        },
        destroyed () {
            document.querySelector('.page-content').removeEventListener('scroll', this.handleScroll, false)
        },
        methods: {
            interceptText (str) {
                return interceptChar(str)
            },
            async showPage () {
                this.$loading.show()
                await this.initPage()
                this.$loading.hide()
            },
            async initPage () {
                this.userToken = this.$store.state.user.userToken
                const params = this.$route.params
                this.travelId = params.travelId
                this.countryName = params.countryName === 'n' ? '' : params.countryName
                this.shipName = params.shipName === 'n' ? '' : params.shipName
                this.orderBy = parseInt(params.orderBy)
                this.offset = parseInt(params.offset)
                const detail = await this.getTravelNoteDetail()
                this.detail = detail

                this.bannerList = detail.banners
                this.articlePartView = detail.articlePartView
                this.tags = this.articlePartView.tags.split(',')
                let reviewDaily = detail.reviewDailyTripPartRecordApiViewModels
                this.reviewDaily = reviewDaily
                this.groups = this.setGroup(reviewDaily, 3)
                this.preArticlePartView = detail.preArticlePartView
                this.nextArticlePartView = detail.nextArticlePartView

                // 初始化微博分享
                this.shareImage = this.bannerList[0].imgUrl
                if (wechatHelper.isWeixinBrowser()) {
                    setTimeout(()=> {
                        wechatHelper.wechatShareConfig(this.articlePartView.title, this.shareText
                        , location.href);
                    }, 3000);
                }
            },
            async getTravelNoteDetail () {
                const {success, data, errMsg} = await api.review.getTravelNoteDetail({
                    countryName: this.countryName,
                    shipName: this.shipName,
                    orderBy: this.orderBy,
                    offset: this.offset,
                    travelId: this.travelId
                })
                if (!success) {
                    console.log(errMsg)
                    return null
                } else {
                    return data
                }
            },
            handleScroll () {
                let $dom = document.querySelector('.page-content')
                let scrollTop = $dom.scrollTop
                let $swiperDom = document.querySelector('.travelDetail-introNav')
                let swiperTop = $swiperDom.offsetTop - 50
                this.dayItemTops = this.getOffsetTop(this.reviewDaily)

                this.shareActive = scrollTop > 0
                this.isFixed = scrollTop > swiperTop
                if (scrollTop < this.dayItemTops[0].top) this.activeDay = 0
                this.dayItemTops.map((item, index, element) => {
                    if (index + 1 < element.length && scrollTop > item.top - 1 && scrollTop < element[index + 1].top ) {
                        this.activeDay = item.day
                    }
                    if (scrollTop > item.top - 1 && index + 1 === element.length) {
                        this.activeDay = item.day
                    }
                })
            },
            setGroup (list, num) {
                let result = []
                for (let i = 0, len = list.length; i < len; i+=num) {
                    result.push(list.slice(i, i + num))
                }
                return result
            },
            getOffsetTop (list) {
                let result = []
                list.map(item => {
                    let $ele = document.querySelector(`.travelDetail-${item.day}`)
                    let top = $ele.offsetTop
                    // 减去容差值
                    top = top - 100
                    result.push({
                        top,
                        day: item.day
                    })
                })
                return result
            },
            goTop () {
                let $dom = document.querySelector('.page-content')
                $dom.scrollTop = 0
            },
            toSimilar (route) {
                let result = route.split('-')
                result.shift()
                result.pop()
                this.$router.push(`/Rccl.Cruise/CruiseSearch/Search?offset=0&ports=${result.toString()}`)
            },
            slideTo (day) {
                this.dayItemTops = this.getOffsetTop(this.reviewDaily) //触发

                let $dom = document.querySelector('.page-content')
                $dom.scrollTop = this.dayItemTops.find(item => item.day === day).top
            },
            shareArticle () {
                if (/MicroMessenger/i.test(navigator.userAgent)) {
                    this.$shareTip.show()
                } else {
                    window.open(`http://service.weibo.com/share/share.php?url=${this.shareUrl}&title=${encodeURIComponent(this.shareText)}&pic=${this.shareImage}&searchPic=false`, '_blank', 'width=600, height=550')
                }
            },
            async upVote () {
                this.$loading.show()
                const {success, data, errMsg} = await api.review.upvote({
                    userId: this.$store.state.user.userReviewToken,
                    articalId: this.travelId
                })
                if (!success) {
                    this.$alert.show(errMsg)
                } else {
                    if (data != this.$store.state.user.userReviewToken) {
                        this.$store.commit('SET_REWARD_TOKEN', data)
                    }
                    this.$alert.show('点赞成功！')
                    this.articlePartView.score++
                }
                this.$loading.hide()
            }
        },
        computed: {
            sailDays () {
                if (typeof(this.articlePartView.sailNights) != 'number') {
                    let sailNights = parseInt(this.articlePartView.sailNights)
                    return sailNights + 1
                } else {
                    return this.articlePartView.sailNights + 1
                }
            }
        }
    }
</script>

<style lang="less" scoped>
    .page {
        display: block;
        background: #F6F7F8 !important;
    }
    .page-content{
        padding-top: 50px;
        padding-bottom: 50px;
        scroll-behavior: smooth;
        overflow-x: hidden;
    }

    .swiper-container{
        padding-bottom: 0;
    }
    /****  banner  ****/
    .travelDetail-banner {
        width: 100%;
        position: relative;
    }
    .travelDetail-bannerTxt {
        width: 100%;
        text-align: center;
        padding:5px 0;
        color: #fff;
        font-size:13px;
        background-color: rgba(0,0,0,.5);
        margin-top:-29px;
        position:relative;
        z-index:2;
    }
    /**** simply travel information ****/
    .travelDetail-info {
        background-color: #fff;
        padding: 0 12px 23px 12px;
        position: relative;
        border-bottom: 1px solid #e7e7e7;
    }
    .travelDetail-infoTop {
        width: 100%;
        overflow: hidden;
        padding: 13px 16px 11px 7px;
        border-bottom: 1px solid #d7d7d7;
    }
    .travelDetail-infoTop .travelDetail-infoTopL {
        float:left;
        font-size:0;
    }
    .travelDetail-infoTop .travelDetail-infoTopR {
        float:right;
        text-align:center;
        font-size:0;
    }
    .travelDetail-infoTop .travelDetail-infoTopL > img {
        width:27px;
        height:27px;
        vertical-align:middle;
    }
    .travelDetail-infoTop .travelDetail-infoTopL > span {
        font-size:13px;
        color:#000;
        vertical-align:middle;
        margin-left:6px;
        font-weight:bold;
    }
    .travelDetail-infoTop .travelDetail-infoTopR > img {
        width:27px;
        height:27px;
        vertical-align:middle;
        margin-right:4px;
    }
    .travelDetail-infoTop .travelDetail-infoTopR > span {
        font-size: 12px;
        color: #000;
        vertical-align:middle;
    }
    .travelDetail-infoMain {
        margin-top:13px;
        clear:both;
        padding:0 11px;
    }
    .travelDetail-infoMain .travelDetail-itemOverFloat {
        overflow:hidden;
        width:100%;
        margin-bottom:9px;
    }
    .travelDetail-infoMain .travelDetail-itemOverFloat > div {
        color: #000;
        font-size: 12px;
    }
    .travelDetail-infoMain .travelDetail-itemLeft {
        float: left;
        width: 57%;
        text-align: left;
    }
    .travelDetail-infoMain .travelDetail-itemRight {
        float: right;
        width: 43%;
        text-align: left;
    }
    .travelDetail-itemTags > div {
        display: inline-block;
        margin-bottom: 4px;
        margin-right: 4px;
    }
    .travelDetail-itemTags > div > span {
        border: 1px solid #338fb3;
        border-radius: 4px;
        padding: 1px 5px;
        color: #338fb3;
        font-size: 12px;
    }
    .travelDetail-infoShare {
        position: fixed;
        right: 0;
        bottom: 30%;
        height: 80px;
        z-index: 10;
    }
    .travelDetail-infoShare .travelDetail-infoShareC {
        background-color: #0073a1;
        border-top-left-radius:20px;
        border-bottom-left-radius:20px;
        width:66px;
        text-align:right;
        height:33px;
        padding-right:5px;
    }
    .travelDetail-infoShare .travelDetail-infoShareC > img {
        width:16px;
        height:20px;
        margin-right:2px;
    }
    .travelDetail-infoShare .travelDetail-infoShareC > span {
        display: inline-block;
        width: 24px;
        font-size: 12px;
        color: #fff;
        transform: scale(.75);
        -webkit-transform: scale(.75);
        -moz-transform: scale(.75);
        -o-transform: scale(.75);
        vertical-align:sub;
    }

    /**** travel intro ****/
    .travelDetail-intro {
        width:100%;
        clear:both;
    }
    .travelDetail-introTitle {
        width: 100%;
        position: relative;
        height:12px;
    }
    .travelDetail-introTitle .travelDetail-introTxt {
        width:80px;
        text-align:center;
        color: #808080;
        font-size:12px;
        position:absolute;
        top:-8px;
        left:50%;
        margin-left:-40px;
        background-color:#f2f2f2;
    }
    .travelDetail-introTitle .travelDetail-introTxtLine {
        width: 248px;
        height: 1px;
        background-color: #acacac;
        margin: 0 auto;
        margin-top: 12px;
    }
    .travelDetail-introNotes {
        width:100%;
        padding:0 12px;
        margin-top:9px;
    }
    .travelDetail-introNotesCon {
        width:100%;
        border-radius:8px;
        background-color:#fff;
        margin-bottom:4px;
    }
    .travelDetail-introNotesCon .introNotesCon-title {
        padding: 14px 16px 9px 16px;
        border-bottom: 1px solid #eee;
        color: #061556;
        font-size:13px;
        font-weight:bold;
    }
    .travelDetail-introNotesCon .introNotesCon-paragraph {
        width:100%;
        padding: 12px 16px 16px 16px;
    }

    /**** pre/next button ****/
    .travelDetail-button {
        margin-top: 15px;
        text-align: center;
        width: 100%;
        padding: 0 12px;
    }
    .travelDetail-buttonItem {
        display:inline-block;
        position:relative;
    }
    .travelDetail-nextBtn {
        margin-left:4px;
    }
    .travelDetail-buttonItem > button {
        width: 171px;
        text-align: center;
        height: 36px;
        background-color: #0c77a5;
        font-size: 13px;
        color: #fff;
        border: none;
    }
    .travelDetail-buttonItem >p{
        margin-top:10px;
        margin-bottom:0;
        width:171px;
        font-size:12px;
        color:#333;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .hold-link {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
    }

    /**** share/praise ****/
    .travelDetail-operate {
        margin-top:24px;
        width:100%;
        text-align:center;
    }
    .travelDetail-operate > div > span {
        color:#333;
        font-size:12px;
    }
    .travelDetail-shareOp {
        display:inline-block;
    }
    .travelDetail-shareOp>img {
        width:28px;
        height:28px;
        display:block;
    }
    .travelDetail-praiseOp {
        display:inline-block;
        margin-left:13px;
    }
    .travelDetail-praiseOp > div {
        width: 28px;
        text-align: center;
        height: 28px;
        background-color: #0c77a5;
        border-radius: 14px;
    }
    .travelDetail-praiseOp > div > img {
        width:16px;
        height:20px;
        vertical-align:middle;
    }

    /**** see similarity cruise ****/
    .travelDetail-otherCruise {
        text-align: center;
        height: 36px;
        line-height: 36px;
        background-color: #f7b611;
        color: #fff;
        font-size: 13px;
        position: relative;
        margin: 17px 12px 0 12px;
    }
    .travelDetail-otherCruise a{
        color:#fff;
    }

    /**** write memories ****/
    .travelDetail-memories {
        margin: 11px;
        width: 100%;
        text-align: center;
    }
    .travelDetail-memories>img {
        width:22px;
        height:25px;
        vertical-align:middle;
    }
    .travelDetail-memories>span {
        color:#333;
        font-size:12px;
        vertical-align:middle;
        margin-left:3px;
    }

    /*爆款推荐*/
    .shipDetail-hotCruise {
        background-color: #fff;
        margin-top:19px;
    }

    /*分享*/
    .reviewDetail-infoShare{
        bottom: 40%;
    }
</style>
